"use client"
import { useTranslation } from "react-i18next"
import { Dropdown } from "react-bootstrap"
import { useLocation, useNavigate } from "react-router-dom"

function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()

  const changeLanguage = (lng) => {
    // Get the current path without the language prefix
    const currentPath = location.pathname.split("/").slice(2).join("/")

    // Navigate to the same page but with new language
    navigate(`/${lng}/${currentPath}${location.search}`)

    // Also change the language in i18next
    i18n.changeLanguage(lng)
  }

  // Get current language
  const currentLang = i18n.language

  // Language options with flags
  const languages = {
    en: { name: "English", flag: "🇬🇧" },
    lv: { name: "Latviešu", flag: "🇱🇻" },
    ru: { name: "Русский", flag: "🇷🇺" },
  }

  return (
    <Dropdown>
      <Dropdown.Toggle variant="link" id="language-dropdown" className="text-decoration-none translation-sidenav">
        {languages[currentLang]?.flag || "🌐"} {languages[currentLang]?.name || "Language"}
      </Dropdown.Toggle>

      <Dropdown.Menu>
      <Dropdown.Item onClick={() => changeLanguage("lv")} active={currentLang === "lv"}>
          🇱🇻 Latviešu
        </Dropdown.Item>
        <Dropdown.Item onClick={() => changeLanguage("en")} active={currentLang === "en"}>
          🇬🇧 English
        </Dropdown.Item>
        <Dropdown.Item onClick={() => changeLanguage("ru")} active={currentLang === "ru"}>
          🇷🇺 Русский
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default LanguageSwitcher
